import { EXERCISES_UI_KEY } from './key'
import EXERCISES_UI_DOMAIN from './domain'

const PATH = {
  QUERY: `${EXERCISES_UI_DOMAIN}.${EXERCISES_UI_KEY.QUERY}`,
  PAGE: `${EXERCISES_UI_DOMAIN}.${EXERCISES_UI_KEY.PAGE}`,
  TYPE_FILTER: `${EXERCISES_UI_DOMAIN}.${EXERCISES_UI_KEY.TYPE_FILTER}`,
  MUSCLE_FILTER: `${EXERCISES_UI_DOMAIN}.${EXERCISES_UI_KEY.MUSCLE_FILTER}`,
  EQUIPMENT_FILTER: `${EXERCISES_UI_DOMAIN}.${EXERCISES_UI_KEY.EQUIPMENT_FILTER}`
}

export default PATH
